import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Categories from './components/Categories';
import ComicGrid from './components/ComicGrid';
import HotRanking from './components/HotRanking';
import EditorsPick from './components/EditorsPick';
import Testimonials from './components/Testimonials';
import Faq from './components/Faq';
import About from './components/About';
import Footer from './components/Footer';
import BackTop from './components/BackTop';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Categories />
        <ComicGrid />
        <HotRanking />
        <EditorsPick />
        <Testimonials />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackTop />
    </>
  );
}